// assets/utm-tracking.js

// --- Cookie helpers ---
function getQueryParameter(name) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
}

function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  const secure = location.protocol === 'https:' ? ';secure' : '';
  document.cookie = `${name}=${encodeURIComponent(value)};${expires};path=/;SameSite=Lax${secure}`;
}

function getCookie(name) {
  const nameEQ = `${name}=`;
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();
    if (cookie.indexOf(nameEQ) === 0) {
      return decodeURIComponent(cookie.substring(nameEQ.length));
    }
  }
  return '';
}

// --- Capture UTMs on page load (first-touch: only set if not already stored) ---
(function () {
  const utmParameters = ['referrer', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'gclid', 'gbraid', 'wbraid'];
  utmParameters.forEach(param => {
    let value = false;
    const cookieName = param;
    if (!getCookie(cookieName)) {
      if (param === 'referrer' && document.referrer) {
        value = document.referrer;
      } else {
        value = getQueryParameter(param);
      }
    }
    if (value) {
      setCookie(cookieName, value, 7);
    }
  });
})();

// --- Write captured values into Shopify cart attributes ---
function pushUtmsToCart() {
  const params = ['referrer', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'gclid', 'gbraid', 'wbraid'];
  const attributes = {};
  let hasValue = false;

  params.forEach(param => {
    const value = getCookie(param);
    if (value) {
      attributes[param] = value;
      hasValue = true;
    }
  });

  if (!hasValue) return;

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes })
  });
}

document.addEventListener('DOMContentLoaded', pushUtmsToCart);


// ============================================================
// --- Contact form lead tracking -> basecloudglobal webhook ---
// Reads ALL fields atomically via FormData at the very start of
// the submit handler (before Shopify's native POST + reload can
// clear them), then sends via sendBeacon (survives page unload).
// ============================================================
(function () {
  'use strict';

  const WEBHOOK_URL = 'https://api.basecloudglobal.com/webhook/2ffdf4729c5b2fddcbff0edd';

  // Pull a value out of a FormData object trying several possible field names.
  function pick(fd, names) {
    for (let i = 0; i < names.length; i++) {
      const v = fd.get(names[i]);
      if (v != null && String(v).trim() !== '') return String(v).trim();
    }
    return '';
  }

  function buildPayload(data) {
    return {
      name:        data.name || '',
      surname:     data.surname || '',
      email:       data.email || '',
      phone:       data.phone || '',
      message:     data.message || '',
      gclid:        getCookie('gclid') || '',
      gbraid:       getCookie('gbraid') || '',
      wbraid:       getCookie('wbraid') || '',
      utm_term:     getCookie('utm_term') || '',
      utm_source:   getCookie('utm_source') || '',
      utm_medium:   getCookie('utm_medium') || '',
      utm_campaign: getCookie('utm_campaign') || '',
      referrer:     getCookie('referrer') || '',
      submitted_at: new Date().toISOString(),
      page_url:     window.location.href
    };
  }

  function sendLead(data) {
    const body = JSON.stringify(buildPayload(data));

    if (navigator.sendBeacon) {
      try {
        const blob = new Blob([body], { type: 'text/plain;charset=UTF-8' });
        if (navigator.sendBeacon(WEBHOOK_URL, blob)) {
          return Promise.resolve({ via: 'beacon', status: 'queued' });
        }
      } catch (e) { /* fall through */ }
    }

    return fetch(WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: body,
      keepalive: true,
      mode: 'no-cors'
    });
  }
  window.sendLead = sendLead; // for manual console testing

  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form || form.tagName !== 'FORM') return;

    const isContactForm =
      form.getAttribute('data-track-lead') === 'true' ||
      form.id === 'ContactForm' ||
      (form.action && form.action.indexOf('/contact') !== -1);

    if (!isContactForm) return;

    // CRITICAL: snapshot all field values NOW, synchronously, from the
    // live form — before the native submit/reload empties anything.
    const fd = new FormData(form);

    const data = {
      name:    pick(fd, ['contact[Name]', 'contact[name]', 'name', 'first_name', 'fname']),
      surname: pick(fd, ['contact[Surname]', 'contact[surname]', 'surname', 'last_name', 'lname']),
      email:   pick(fd, ['contact[email]', 'contact[Email]', 'email']),
      message: pick(fd, ['contact[Comment]', 'contact[message]', 'message', 'body'])
    };

    try { sendLead(data); } catch (err) { /* no-op */ }
  }, true);
})();